import React, { useState } from 'react';
import ConfirmationModal from '../../../ConfirmationModal';
import './DeleteButtonWithConfirm.scss';

interface DeleteButtonWithConfirmProps {
  /** Function to handle delete action */
  onDelete: () => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
  /** Button label */
  label?: string;
  /** Confirmation modal title */
  confirmTitle?: string;
  /** Confirmation modal message */
  confirmMessage?: string;
  /** Confirm button text */
  confirmText?: string;
  /** Cancel button text */
  cancelText?: string;
}

/**
 * Delete button component with confirmation modal
 * Opens a beautiful confirmation modal instead of window.confirm
 */
const DeleteButtonWithConfirm: React.FC<DeleteButtonWithConfirmProps> = ({
  onDelete,
  className = '',
  disabled = false,
  label = 'Delete',
  confirmTitle = 'Confirm Delete',
  confirmMessage = 'Are you sure you want to delete this item? This action cannot be undone.',
  confirmText = 'Delete',
  cancelText = 'Cancel'
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    onDelete();
    setShowConfirm(false);
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  return (
    <>
      <button
        className={`delete-button-with-confirm ${className}`}
        onClick={handleClick}
        disabled={disabled}
        type="button"
      >
        {label}
      </button>

      <ConfirmationModal
        isOpen={showConfirm}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        title={confirmTitle}
        message={confirmMessage}
        confirmText={confirmText}
        cancelText={cancelText}
        type="danger"
      />
    </>
  );
};

export default DeleteButtonWithConfirm;

